export interface CustomerListParams {
  q?: string;
  sort?: string;
  page?: number;
  size?: number;
  nationality?: string;
}

export const customerKeys = {
  all: ['customers'] as const,
  lists: () => [...customerKeys.all, 'list'] as const,
  list: (p: CustomerListParams) => [...customerKeys.lists(), p] as const,
  detail: (id: string) => [...customerKeys.all, 'detail', id] as const,
  deals: (id: string) => [...customerKeys.all, 'detail', id, 'deals'] as const,
  picker: (q: string) => [...customerKeys.all, 'picker', q] as const,
  activity: (id: string) => [...customerKeys.all, 'detail', id, 'activity'] as const,
  duplicates: (id: string) => [...customerKeys.all, 'detail', id, 'duplicates'] as const,
  corrections: (id: string) => [...customerKeys.all, 'detail', id, 'corrections'] as const,
  documentVersions: (id: string, documentId: string) => [...customerKeys.all, 'detail', id, 'documents', documentId, 'versions'] as const,
  /** Employer master options for the employment picker (customers reads /employers directly). */
  employerOptions: (q: string) => [...customerKeys.all, 'employer-options', q] as const,
};

/**
 * Root of the deals feature's keys. Customers cannot import the deals feature (the edge is deals → customers), so
 * customer changes that show on deals (name, CIF, moved deals) invalidate by this root.
 */
export const DEALS_ROOT_KEY = ['deals'] as const;
